import React from 'react';
import { useNavigate } from 'react-router-dom';
import authService from '../services/authService';

const Navbar = () => {
  const navigate = useNavigate();
  const user = authService.getCurrentUser();

  const handleLogout = () => {
    authService.logout();
    navigate('/login');
  };

  return (
    <div className="navbar">
      <div className="navbar-title">
        <h1 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
          Welcome back, {user?.username || 'User'}!
        </h1>
        <p style={{ margin: '5px 0 0 0', fontSize: '13px', color: '#666' }}>
          Manage your YouTube content efficiently
        </p>
      </div>
      <div className="navbar-user">
        <button className="btn btn-secondary" onClick={handleLogout}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default Navbar;
